import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import {AppComponent} from '../../app.component';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { AlertService } from '../../alertpopup/_alert';
export class FetchCommunityData {
  AllocateUser: string;
  AllocateUnPaidUser: string;
  ConsumedPaidUser: string;
  ConsumedUser: string;
}

@Component({
    selector: 'app-user-master',
    templateUrl: './user-master.component.html',
    styleUrls: ['./user-master.component.css'],
    standalone: false
})
export class UserMasterComponent implements OnInit {
  url: string;
  UserDetail: any;
  modalURL: any;
  ModelFor: string;
  CallFunctionOnCloseModal: any;
  height: string;
  modaldialog: string;
  pageNumber: number;
  RightsID: string;
  FormSearchEmployee: FormGroup;
  MsgType: number;
  DisplayMessage: string;
  AllocateUser: string;
  AllocateUnPaidUser: string;
  ConsumedPaidUser: string;
  ConsumedUser: string;
  totalUser:any;
  totalConsumed: any;
  UserCondition: any;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  filteredData: any[];
  pageSize = 10;
  pageIndex = 0;
  totalRecords = 0;
  constructor(private router: Router,  private http: HttpClient, private formBuilder: FormBuilder, protected alertService: AlertService) { this.url = AppComponent.baseURL; }

  ngOnInit() {
    //this.AssignUser=+localStorage.getItem('Users');
    //localStorage.setItem('Users', userInfo.NoOfUser.toString());
    //localStorage.setItem('Company', userInfo.NoOfCompany.toString());
    this.RightsID = localStorage.getItem('UserRight');
    if (this.RightsID.includes('202040001') || this.RightsID.includes('202040021') || this.RightsID.includes('202040000')) {
      } else {
        window.location.href = "module/0";
      }

    this.MsgType = 1; // Loading
    this.pageNumber = 1;
    this.FetchUserMaster();
    this.FormSearchEmployee = this.formBuilder.group({
      txtSearch: [''], advanceSearchValue: ['']
    });
    let element: HTMLElement;
    element = document.getElementsByClassName('modal-backdrop')[0] as HTMLElement;
    if (element != null) {
      element.remove();
    }
    this.FormSearchEmployee.get('txtSearch').valueChanges
    .pipe(
      debounceTime(300),
      distinctUntilChanged()
    )
    .subscribe(value => {
      this.filteredTable(value);
    });
  }
  onPageSizeChange(size: number) {
    this.pageSize = size;
    this.pageNumber = 1; 
    this.filteredTable('')
  }
  OpenModal(url, cID, modelName, urld)    {
    let myDate = Math.floor(Math.random() * 6) + 1 ;
    this.modalURL =  url + "/" + cID;
    this.CallFunctionOnCloseModal = urld;
    this.ModelFor = modelName;
    if (url == "add-user-master") { this.modaldialog = "modal-dialog-UserMaster";   this.height = "750 px"; }
    if (url == "setpassword") { this.modaldialog = "modal-dialog-SetPassword";  this.height = "290 px"; }
  }
  onSearchEmployee(SearchData) {

    this.http.get(this.url + 'User/SearchUser?filter=' + SearchData.txtSearch)
    .subscribe( (data) => {
     // console.log(data);
      if (data == null || data.toString() == "[]") {
        this.MsgType = 2; // No Data Found
        this.DisplayMessage = "No Data Found";
        this.UserDetail = null;
      } else {
        this.MsgType = 0; // No Message
        this.UserDetail = JSON.parse(data.toString());
      }
      },
      (error) => {
         this.MsgType = 3; // Error Message
         this.DisplayMessage = error.message;
       }
    );
  }
  FetchUserMaster() {
    this.modalURL = '' ;
    this.http.get(this.url + 'User/SearchUser?filter=' + '')
    .subscribe( (data) => {
    //  console.log(data);

      if (data == null || data.toString() == "[]") {
        this.MsgType = 2; // No Data Found
        this.DisplayMessage = "No Data Found";
        this.UserDetail = null;
      } else {
        this.MsgType = 0; // No Message
        this.UserDetail = JSON.parse(data.toString());
        this.totalRecords = this.UserDetail.length;
        this.filteredTable('');
      }
      this.http.get(this.url + 'CommunityDetail/FetchCommunityDetail')
    .subscribe( (data1) =>   {
        if (data1 == null) {  } else {
          const CommunityData: FetchCommunityData = JSON.parse(data1.toString())[0];
          this.AllocateUser=CommunityData.AllocateUser;
          this.AllocateUnPaidUser=CommunityData.AllocateUnPaidUser;
          this.ConsumedPaidUser=CommunityData.ConsumedPaidUser;
          this.ConsumedUser=CommunityData.ConsumedUser;
          this.totalUser=+this.AllocateUser + +this.AllocateUnPaidUser;
          this.totalConsumed=+this.ConsumedUser + +this.ConsumedPaidUser;
          if(this.totalConsumed<this.totalUser){this.UserCondition=1;}else{this.UserCondition=0;}
      }});
      },
      (error) => {
         this.MsgType = 3; // Error Message
         this.DisplayMessage = error.message;
       }
    );
  }
  DeleteUserMaster(UserID) {
    this.alertService.showConfirm('Are you sure to delete it?').then((result) => {
      if (result) {
        this.http.get(this.url + 'User/DeleteUserMaster?ID=' + UserID)
    .subscribe( (data) =>   {
      if (data == null) { this.alertService.showError('You Can not Delete This User'); } else {
        this.alertService.showSuccess('User Deleted Successfully'); this.FetchUserMaster();
      }
       }
    );
      }   
    })
  }

  filteredTable(searchText: string) {
    if(!searchText){
      this.filteredData = [...this.UserDetail];
      return;
    }
    this.filteredData = this.UserDetail.filter(row =>
      Object.values(row).some(val =>
        val?.toString().toLowerCase().includes(searchText.toLowerCase())
      )
    );
  }
}